import { useFirstPartnerApplicationsByPerson } from '~domains/partner-application/entities/application';

import { ErrorScreen } from '~shared/ui/error-screen';
import { Loader } from '~shared/ui/loader';

import {
  ApprovedScreen,
  InProgressScreen,
  NewApplicationScreen,
  NoApplicationScreen,
  SignedScreen,
} from './screens';

export const PartnerApplicationMenuPage = () => {
  const applicationQuery = useFirstPartnerApplicationsByPerson();

  if (applicationQuery.isError) {
    return <ErrorScreen message="Failed to load applications." />;
  }

  if (applicationQuery.isLoading) {
    return <Loader />;
  }

  if (!applicationQuery.data) {
    return <NoApplicationScreen />;
  }

  const { applicationId, status } = applicationQuery.data;

  switch (status) {
    case 'NEW':
      return <NewApplicationScreen applicationId={applicationId} />;
    case 'IN_PROGRESS':
      return <InProgressScreen />;
    case 'APPROVED':
      return <ApprovedScreen applicationId={applicationId} />;
    case 'SIGNED':
      return <SignedScreen />;
    default:
      return null;
  }
};
